import { useMutation } from 'react-query';
import Promise from 'bluebird';
import { uploadAsset } from '../http/upload-assets-client';

export function useUploadData() {
  const { mutateAsync, isLoading, data } = useMutation(
    (bodyFormData) => {
      return Promise.try(() => {
        return uploadAsset(bodyFormData)
          .then((response) => {
            console.log('response 0 : ', response[0].id);
            return response[0].id;
          });
      });
    },
  );

  return {
    uploadData: mutateAsync,
    uploadedData: data,
    uploadIsLoading: isLoading,
  };
}
